import React from "react";
import clsx from "clsx";
import Address from "./Address";
import Footermenu from "./Footermenu";
import SocialMediaIcons from "./../../SocialMediaIcons/index";
import Map from "./Map";

import styles from "./Row1.styles";

const Row1 = () => {
	const css = styles();

	return (
		<div className={clsx(css.row1, "mco-view-component-footer-row1")}>
			<div className={clsx(css.column1, "mco-view-component-footer-row1__column1")}>
				<Address />
				<SocialMediaIcons />
			</div>
			<div className={clsx(css.column2, "mco-view-component-footer-row1__column2")}>
				<Footermenu />
			</div>
			<div className={clsx(css.column3, "mco-view-component-footer-row1__column3")}>
				<Map />
			</div>
		</div>
	);
};

export default Row1;
